module.exports = __webpack_public_path__ + "img/guabbi.7655a1c2.png";